import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import SocialSharingLinks from "@modules/study/common/social_sharing_links";
const baseUrl = process.env.NEXT_PUBLIC_URL;
import styles from "./study_links.module.scss";

export const StudyLinks = ({ pageData, name, linkType }) => {
  const link = useRouter();
  const { asPath, query } = link;

  return (
    <>
      <section className={styles.section_links}>
        {asPath === `/study/${name}` && (
          <SocialSharingLinks
            url={`${baseUrl}/${linkType}/${name}/${pageData?.slug}`}
            title={pageData?.pageTitle}
            className={styles.social_link_wrapper}
          />
        )}

        <div className={styles.links_wrapper}>
          <div className="container">
            <div className={styles.links_container}>
              <ul>
                {pageData?.pageMenuGroup?.map((menu, i) => {
                  let pageSlug =
                    menu.pageSlug === menu.referenceColumnName
                      ? name
                      : `${name}/${menu.pageSlug}`;

                  return (
                    <li key={i}>
                      <Link legacyBehavior href={`/${linkType}/${pageSlug}`}>
                        <a
                          className={`${
                            asPath === `/${linkType}/${pageSlug}`
                              ? `${styles.active}`
                              : ""
                          }`}
                        >
                          {menu?.pageTitle}
                        </a>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StudyLinks;
